<template>
  <div class="confirm-cancellation">
    <button
      class="confirm-cancellation__close"
      @click="$emit('close-cancel-subscription-modal')"
    >
      <span class="confirm-cancellation__close--icon material-icons"
        >clear</span
      >
    </button>
    <div class="confirm-cancellation__wrapper">
      <h6 class="confirm-cancellation__title">Why are you leaving?</h6>
      <div class="confirm-cancellation__selections">
        <button
          v-for="field in cancellationFields"
          @click="updateSelections(field.slug)"
          v-show="field.field_type === 'checkbox'"
          :key="field.id"
          :class="[
            'confirm-cancellation__selection',
            surveySelections[field.slug] &&
              'confirm-cancellation__selection--selected',
          ]"
        >
          <span class="confirm-cancellation__selection--text">{{
            getFriendlyString(field.slug)
          }}</span>
        </button>
      </div>
      <div class="confirm-cancellation__ancillary">
        <div
          v-if="isCompetitorFieldChecked"
          class="confirm-cancellation__selector-wrapper"
        >
          <!-- ToDo: refactor light dropdown -->
          <select
            v-model="selectedCompetitor"
            class="confirm-cancellation__selector"
          >
            <option value="" selected>Select competitor</option>
            <option
              v-for="(competitor, key) in optionsForCompetitor"
              :key="key"
              :value="key"
              >{{ competitor }}</option
            >
          </select>
          <input
            v-if="isCustomCompetitorSelected"
            v-model="customCompetitor"
            type="text"
            placeholder="Specify competitor"
            class="confirm-cancellation__custom-input"
          />
        </div>
        <div class="confirm-cancellation__textarea-wrapper">
          <textarea
            v-model="customReason"
            class="confirm-cancellation__textarea"
            placeholder="Other? Please explain"
            rows="5"
          />
        </div>
      </div>
    </div>
    <div class="confirm-cancellation__actions">
      <p class="confirm-cancellation__action-confirm">
        Are you sure you want to unsubscribe?
      </p>
      <button
        class="btn btn--primary"
        @click="$emit('close-cancel-subscription-modal')"
      >
        Nevermind
      </button>
      <button class="btn btn--secondary" @click="handleConfirmationClick">
        Yes, unsubscribe me
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmCancellation',
  props: {
    survey: {
      type: Object,
      required: true,
    },
    subscriptionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      surveySelections: {},
      selectedCompetitor: '',
      customCompetitor: '',
      customReason: '',
    }
  },
  computed: {
    cancellationFields() {
      const {
        survey: {
          survey_fields: { data },
        },
      } = this
      return data
    },
    isCompetitorFieldChecked() {
      const { surveySelections } = this
      return surveySelections.i_prefer_a_competitor
    },
    optionsForCompetitor() {
      const field = this.cancellationFields.find(
        f => f.slug === 'select_preferred_competitor'
      )
      const {
        field_meta: { select },
      } = field
      return select
    },
    isCustomCompetitorSelected() {
      return this.selectedCompetitor === 'other'
    },
  },
  methods: {
    updateSelections(slug) {
      this.surveySelections[slug] = !this.surveySelections[slug]
    },
    getFriendlyString(slug) {
      const slugMap = {
        content_was_too_difficult: 'Content was too difficult',
        was_missing_content_that_i_wanted: 'Was missing content that I wanted',
        too_expensive: 'Too expensive',
        i_completed_the_content_that_i_wanted_to_learn:
          'I completed the content that I wanted to learn',
        i_thought_this_was_the_free_starter_pass:
          'I thought this was the free starter pass',
        i_didnt_use_my_subscription: "I didn't use my subscription",
        too_many_bugs_in_the_platform: 'Too many bugs in the platform',
        the_platform_was_difficult_to_navigate:
          'The platform was difficult to navigate',
        i_prefer_a_competitor: 'I prefer a competitor',
      }
      return slugMap[slug]
    },
    gatherResponses() {
      const uniqueSlugMap = {
        other: this.customReason,
        other_competitor: this.customCompetitor,
        select_preferred_competitor: this.selectedCompetitor,
      }
      return this.cancellationFields.reduce((acc, field) => {
        if (Object.keys(uniqueSlugMap).includes(field.slug)) {
          acc[field.slug] = uniqueSlugMap[field.slug]
        } else {
          acc[field.slug] = this.surveySelections[field.slug]
        }
        return acc
      }, {})
    },
    preparePayload() {
      const {
        survey: { slug: survey_slug },
        subscriptionId: subscription_id,
      } = this
      return {
        survey_slug,
        subscription_id,
        responses: this.gatherResponses(),
      }
    },
    handleConfirmationClick() {
      const payload = this.preparePayload()
      this.$emit('handle-confirm-click', payload)
    },
    setUpSelectedReasons() {
      this.surveySelections = this.cancellationFields.reduce((acc, field) => {
        acc[field.slug] = false
        return acc
      }, {})
    },
  },
  created() {
    this.setUpSelectedReasons()
  },
}
</script>

<style lang="scss">
.confirm-cancellation {
  position: relative;
  padding: 0 25px;
  top: 0;
  margin: 0 auto;
  background: rgba(17, 17, 17, 1);
  width: 100%;
  min-height: 410px;
  overflow: scroll;
  @include tablet {
    top: 3%;
    max-width: 850px;
    min-height: 410px;
    height: auto;
    border-radius: 25px;
  }
  @include desktop {
    overflow: hidden;
  }
  @media screen and (max-height: 800px) {
    overflow: scroll;
    height: 100%;
    width: 100%;
  }
  &__close {
    width: 50px;
    height: 50px;
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 5px;
    z-index: 2;
    &--icon {
      color: var(--white);
    }
  }
  &__wrapper {
    display: flex;
    gap: 30px;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  &__title {
    color: var(--white);
    font-size: rem(40px);
    font-family: var(--font-bold);
    padding: 0;
    margin: 75px auto 25px auto;
  }
  &__selections {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
    @include tablet {
      gap: 10px;
    }
  }
  &__selection {
    background: transparent;
    color: var(--white);
    padding: 5px;
    border-radius: 16px;
    border: 1px solid var(--glass-light-grey, #bbbcc7);
    background: var(
      --glass-extra-light,
      linear-gradient(
        112deg,
        rgba(187, 188, 199, 0.4) -46.39%,
        rgba(187, 188, 199, 0) 112.38%
      )
    );
    cursor: pointer;
    @include tablet {
      padding: 5px 10px;
    }
    &:hover {
      opacity: 0.8;
    }
    &--selected {
      background: #ef7e224b;
      border-color: var(--orange);
    }
    &--text {
      padding: 0 5px;
      font-size: rem(14px);
      white-space: nowrap;
    }
  }
  &__ancillary {
    width: 100%;
    padding: 0 15px;
    @include tablet {
      padding: 0 60px;
    }
  }
  &__selector-wrapper {
    width: 100%;
    margin: 5px 0;
    display: flex;
    flex-wrap: wrap;
    @include tablet {
      flex-wrap: nowrap;
    }
  }
  &__selector {
    width: 100%;
    padding: 15px;
    background: #f4f4f4;
    border: 1px solid transparent;
    &:focus {
      border: 1px solid var(--orange);
    }
  }
  &__custom-input {
    width: 100%;
    padding: 15px;
    background: #f4f4f4;
    border: 1px solid transparent;
    margin: 0 0 0 15px;
    &:focus {
      border: 1px solid var(--orange);
    }
  }
  &__textarea-wrapper {
    width: 100%;
    margin: 15px 0 0 0;
  }
  &__textarea {
    width: 100%;
    padding: 15px;
    border-radius: 5px;
    border: none;
    background: #f4f4f4;
    font-size: rem(12px);
  }
  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 0px auto;
    padding: 10px 0 50px 0;
    gap: 20px;
    @include tablet {
      justify-content: center;
    }
  }
  &__action-confirm {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-weight: 500;
    line-height: rem(24px);
    margin: 0 0 20px 0;
  }
  &__cancel-btn {
    color: var(--black);
    border: 3px solid var(--orange);
    margin: 0 0 25px 0;
    padding: 10px 25px;
    font-weight: 700;
    &:hover {
      color: var(--white);
    }
  }
  &__confirm-btn {
    background: none;
    border: none;
    text-decoration: underline;
    font-size: rem(16px);
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
